import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

const RESOURCE_COLORS = {
  "WC-ASSM-01": "#3B82F6", "WC-ASSM-02": "#6366F1", "WC-FILL-01": "#10B981",
  "WC-PACK-01": "#F59E0B", "WC-QC-01": "#8B5CF6", "WC-WELD-01": "#EF4444",
  "WC-CNC-01": "#EC4899", "LABOR-SKILLED": "#14B8A6", "LABOR-GENERAL": "#64748B",
};

export const getResourceColor = (resourceId) => RESOURCE_COLORS[resourceId] || "#6B7280";

const WorkCentersGrid = ({ resources }) => {
  return (
    <Card className="card-industrial">
      <CardHeader>
        <CardTitle className="text-base">Work Centers</CardTitle>
        <CardDescription>Available manufacturing resources</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-3">
          {resources.map((resource) => (
            <div key={resource.id} className="p-3 border rounded-lg flex items-center gap-3">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: getResourceColor(resource.id) }} />
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm truncate">{resource.name}</p>
                <p className="text-xs text-muted-foreground">{resource.id}</p>
              </div>
              <Badge variant="outline" className="text-xs">{resource.capacity_per_day}h</Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default WorkCentersGrid;
